import * as Actions from '../../../redux/actions'

import { CheckLightIcon, CircleDownIcon, CircleUpIcon } from "../Common/SVGBank"

import MenuItem from '@material-ui/core/MenuItem'
import React from 'react'
import Typography from '@material-ui/core/Typography'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

const BarsFilterTypeMenuItem = connect((state) => ({
    selectedSubtypes: state.FormBank.HotelSearch.selectedSubtypes,
    lazyLoading: state.FormBank.HotelSearch.lazyLoading,
    switchFeatureContainer: state.FormBank.FeatureFormat,
    establishments: state.FormBank.HotelSearch.establishments,
    establishmentsToFilter: state.FormBank.HotelSearch.establishmentsToFilter,
    hotel_form_state: state.FormBank.HotelSearch.hotel_form_state,
    lazyLoading: state.FormBank.HotelSearch.lazyLoading,


}), {
    addSelectedSubTypeHotels: Actions.addSelectedSubTypeHotels,
    deleteSelectedSubTypeHotels: Actions.deleteSelectedSubTypeHotels,
    handleGroupSubTypeHotels: Actions.handleGroupSubTypeHotels,
})(({
    selectedSubtypes,
    lazyLoading,
    addSelectedSubTypeHotels,
    deleteSelectedSubTypeHotels,
    handleGroupSubTypeHotels,
    subtypeGroup,
    switchFeatureContainer,
    establishments,
    establishmentsToFilter,
    hotel_form_state,
}) => {
    const switchFeatureContainerColorLight = switchFeatureContainer.color + "35"
    const barsStyles = makeStyles(theme => ({
        root: {
            display: 'flex',
            '& .MuiListItem-root': {
                boxShadow: "0 0 0 0 rgba(0,123,255,.25)",
                font: "16px/16px Futura Md BT",
                color: "#707070",
            },
        },
        buttonText: {
            color: switchFeatureContainer.color,
            textAlign: "left",
            font: "16px/22px Futura Md BT",
            letterSpacing: "0",
            padding: "5px",
            '&:focus': {
                border: "0",
                outline: "0px",

            }
        },
        timesDiv: {
            marginRight: "10px",
            marginLeft: "115px",
            display: "inline-block",
            textAlign: "right",
        },
        popper: {
            zIndex: "3",
            marginTop: "20px",
            font: "16px/16px Futura Md BT",
            '& .MuiListItem-root:hover': {
                backgroundColor: switchFeatureContainerColorLight,
            },
        },
        paddingLeft30: {
            paddingLeft: "30px"
        },
        backgroundSelection: {
            '&:hover': {
                backgroundColor: switchFeatureContainer.color
            }
        },
        paper: {
            marginRight: theme.spacing(2),
        },
        outline: {
            '& .MuiList-root .MuiList-padding': {
                outline: "0px",
            }
        },
    }))
    const [open, setOpen] = React.useState(false)

    const classesBars = barsStyles()

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen)
    }
    let  [,setState]=React.useState();
    const handleAddSelectedSubTypeHotels = (establishmentsToFilter, subtype, lazyLoading, selectedSubtypes) => {
        addSelectedSubTypeHotels(establishmentsToFilter, subtype, selectedSubtypes, hotel_form_state, lazyLoading)
        setState({});
    }

    const limit=10;

    return (
        <div className="position-relative">
            <div>
                {subtypeGroup.subtypes !== undefined
                    && subtypeGroup.subtypes.length > 0 && switchFeatureContainer.featureId !== '4' &&
                    <div style={{ display: "flex", width: "200px", paddingLeft: "10px", paddingRight: "10px", font: "16px/16px Futura Md BT", outline: "0px", }} >
                        <div style={{ flexGrow: "1", paddingTop: "10px", paddingBottom: "6px", cursor: "pointer", outline: "0px", }}
                            onClick={() => { handleGroupSubTypeHotels(establishmentsToFilter, subtypeGroup.subtypes, lazyLoading, selectedSubtypes) }}>{subtypeGroup.title}
                        </div>
                    </div>
                }
                {subtypeGroup.subtypes !== undefined
                    && subtypeGroup.subtypes.length > 0
                    && subtypeGroup.subtypes.map((subtype, subtype_index) => {
                        return (
                            open || subtype_index < limit ?
                                <MenuItem key={subtype_index}
                                    className={classesBars.outline}
                                    onClick={
                                        () => {
                                            selectedSubtypes.find(val => val.id === subtype.id) ?
                                                deleteSelectedSubTypeHotels(subtype, selectedSubtypes, establishmentsToFilter, hotel_form_state, lazyLoading)
                                                :
                                                handleAddSelectedSubTypeHotels(establishmentsToFilter, subtype, lazyLoading, selectedSubtypes)
                                        }}
                                >
                                    <Typography variant="inherit" noWrap style={{ width: "200px", font: "15px/15px Futura Lt BT" }}>
                                        {subtype.title}
                                    </Typography>
                                    {selectedSubtypes.find(val => val.id === subtype.id) && <CheckLightIcon fill={switchFeatureContainer.color} />}
                                </MenuItem>
                                : ""
                        )
                    })}

            </div>

            <div className="d-inline-block position-absolute" style={{ zIndex: "4", right: "2px", bottom: "3px" }}>
                {subtypeGroup.subtypes !== undefined
                    && subtypeGroup.subtypes.length > limit && open && <div onClick={() => handleToggle()}> <CircleUpIcon /></div>}
                {subtypeGroup.subtypes !== undefined
                    && subtypeGroup.subtypes.length > limit && !open && <div onClick={() => handleToggle()}> <CircleDownIcon /></div>}
            </div>
        </div>
    )
})

export default BarsFilterTypeMenuItem